import { Link } from 'react-router-dom'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const appVersion = '1.0.3'

  const links = {
    LINKS: [
      { name: 'All Tools', href: '/supported-formats' },
      { name: 'Guides', href: '/guides' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Pricing', href: '/pricing' },
      { name: 'About', href: '/about' },
    ],
    LEGAL: [
      { name: 'Terms of services', href: '/terms' },
      { name: 'Privacy policy', href: '/privacy' },
      { name: 'Codec licensing', href: '/codec-licensing' },
    ],
    VIDEO_CONVERTERS: [
      { name: 'MP4 Converter', href: '/mp4-converter' },
      { name: 'Video to GIF', href: '/video-to-gif' },
      { name: 'MOV to MP4', href: '/mov-to-mp4' },
      { name: 'MP4 to MP3', href: '/mp4-to-mp3' },
      { name: 'Video Compressor', href: '/video-compressor' },
    ],
    IMAGE_CONVERTERS: [
      { name: 'HEIC to JPG', href: '/heic-to-jpg' },
      { name: 'WebP to JPG', href: '/webp-to-jpg' },
      { name: 'WebP to PNG', href: '/webp-to-png' },
      { name: 'PNG to SVG', href: '/png-to-svg' },
      { name: 'Image Compressor', href: '/image-compressor' },
    ],
    DOCUMENT_CONVERTERS: [
      { name: 'PDF to Word', href: '/pdf-to-word' },
      { name: 'DOCX to PDF', href: '/docx-to-pdf' },
      { name: 'JPG to PDF', href: '/jpg-to-pdf' },
      { name: 'PDF Merger', href: '/pdf-merger' },
      { name: 'Compress PDF', href: '/compress-pdf' },
    ]
  }

  return (
    <footer className="bg-[#111827] text-gray-400 py-20 px-4 border-t border-gray-800">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12">
        <div className="col-span-2 lg:col-span-2 space-y-6">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center group-hover:bg-primary-500 transition-colors">
              <span className="text-white font-black text-lg">H</span>
            </div>
            <span className="text-xl font-bold text-white tracking-tight">Joy File Convert</span>
          </Link>
          <p className="max-w-sm leading-relaxed">
            Convert almost any file locally - nothing gets uploaded to the cloud. Do 3985 document, video, image, audio & email conversions with one app for Mac, Windows & Linux.
          </p>
          <p className="text-sm">
            Copyright © {currentYear} - All rights reserved <span className="ml-2 text-gray-600">v{appVersion}</span>
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-widest">Links</h4>
          <ul className="space-y-4 text-sm">
            {links.LINKS.map(link => (
              <li key={link.name}>
                <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-widest">Legal</h4>
          <ul className="space-y-4 text-sm">
            {links.LEGAL.map(link => (
              <li key={link.name}>
                <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-widest">Video Tools</h4>
          <ul className="space-y-4 text-sm">
            {links.VIDEO_CONVERTERS.map(link => (
              <li key={link.name}>
                <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-widest">Image Tools</h4>
          <ul className="space-y-4 text-sm">
            {links.IMAGE_CONVERTERS.map(link => (
              <li key={link.name}>
                <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-widest">Doc Tools</h4>
          <ul className="space-y-4 text-sm">
            {links.DOCUMENT_CONVERTERS.map(link => (
              <li key={link.name}>
                <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
